import * as React from 'react';
import { ILocation } from '../../../../../types/location';
import { ErrorBoundary } from '../ErrorBoundary';
import { NotFound } from '../NotFound';
import { RegionsListMobile } from '../RegionsListMobile';

export interface IGeoLocationModalContentProps {
  isError?: boolean;
  isSearchShown?: boolean;
  specialLocations: ILocation[];
  locations: ILocation[];
  foundLocations: ILocation[];

  onRetry(): void;
  onLocationSelect(location: ILocation): void;
}

export const GeoLocationModalContent: React.FC<IGeoLocationModalContentProps> = props => {
  const { foundLocations, onLocationSelect, isError, locations, isSearchShown, onRetry, specialLocations } = props;

  /** Ошибка загрузки регионов **/
  if (isError) {
    return <ErrorBoundary onClick={onRetry} />;
  }

  /** Поиск не дал результатов **/
  if (isSearchShown && !foundLocations.length) {
    return <NotFound />;
  }

  /** Есть результаты поиска **/
  if (isSearchShown) {
    return <RegionsListMobile onLocationSelect={onLocationSelect} locations={foundLocations} />;
  }

  /** Блоки основных и популярных регионов **/
  return (
    <>
      <RegionsListMobile onLocationSelect={onLocationSelect} locations={specialLocations} />
      <RegionsListMobile onLocationSelect={onLocationSelect} locations={locations} />
    </>
  );
};

GeoLocationModalContent.displayName = 'GeoLocationModalContent';
